module.exports = __webpack_public_path__ + "media/images/cross-ac2c66032a89ad4d30f9418238ac3e93.svg";